import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import AdminPage from "../../components/AdminPage";
import TableComponent from "../../components/adminTableComponent";
import { LoaderWrapper } from "../../components/LoaderWrapper";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import { SpecificView } from "../../components/SpecificView/SpecificView";
import { AddCategory } from "./addModal";
import { loadSkills } from "./loadData";
import { SkillsHeaders } from "./tableHeaders";

const Categories = ({}) => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [opened, setOpened] = useState(false);
  const [viewModalState, setViewModalState] = useState(false);
  const [viewModalData, setViewModalData] = useState({});
  const [update, setUpdate] = useState(false);

  useEffect(() => {
    loadSkills(setLoading).then(setCategories);
  }, [location.pathname, update]);

  return (
    <AdminPage title="Categories">
      <ModalWrapper
        opened={viewModalState}
        setOpened={setViewModalState}
        title={"Category Details"}
        InternalComponent={
          <SpecificView
            name={viewModalData.categoryName}
            description={viewModalData.categoryDescription}
            date={viewModalData?.createdDate}
            status={viewModalData?.state}
          />
        }
      />

      <AddCategory
        opened={opened}
        setOpened={setOpened}
        setUpdate={setUpdate}
      />
      <LoaderWrapper loading={loading}>
        <TableComponent
          headCells={SkillsHeaders}
          rowData={categories}
          showAddButton={true}
          setOpened={setOpened}
          setViewModalData={setViewModalData}
          setViewModalState={setViewModalState}
        />
      </LoaderWrapper>
    </AdminPage>
  );
};

export default withTranslation()(Categories);
